// src/components/EngineerSettings.js
import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Divider,
  Stack,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import NotificationSettings from './NotificationSettings';

function EngineerSettings({ onBack }) {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#0f172a',
        p: 2,
      }}
    >
      <Box sx={{ maxWidth: 700, mx: 'auto' }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 3,
            gap: 2,
          }}
        >
          <IconButton
            onClick={onBack}
            sx={{
              bgcolor: 'rgba(255,255,255,0.1)',
              color: 'white',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 700, color: 'white' }}>
            Engineer Settings
          </Typography>
        </Box>

        <Stack spacing={3}>
        {/* Push Notifications Settings */}
        <NotificationSettings user={user} />

        {/* Account Details */}
        <Paper sx={{ p: 3, backgroundColor: '#1e293b' }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'white' }}>
            Account Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Email
              </Typography>
              <Typography variant="body1" color="white">
                {user?.email || 'Not available'}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                User ID
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                {user?.uid || 'Not available'}
              </Typography>
            </Box>
          </Stack>
        </Paper>

        {/* App Info */}
        <Paper sx={{ p: 3, backgroundColor: '#1e293b' }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'white' }}>
            About
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                App Version
              </Typography>
              <Typography variant="body2" color="white">
                1.0.0
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Platform
              </Typography>
              <Typography variant="body2" color="white">
                PWA
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Stack>
      </Box>
    </Box>
  );
}

export default EngineerSettings;